import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkTokenValidity = async () => {
      const token = localStorage.getItem("@USER_TOKEN_FACTORY");
      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        const response = await api.get(`panel/user/by/id`);
        if (response.status === 200) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("@USER_TOKEN_FACTORY");
          setIsAuthenticated(false);
        }
      } catch (error) {
        localStorage.removeItem("@USER_TOKEN_FACTORY");
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkTokenValidity();
  }, []);

  useEffect(() => {
    
    if (!loading && !isAuthenticated) {
      navigate('/');
    }
  }, [loading, isAuthenticated, navigate]);

  if (loading) {
    return <></>
  }

  return isAuthenticated ? children : null;
};

export default PrivateRoute;
